import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["query", "results", "selectedLabel", "otherPersonId"]

  searchTimer = null

  connect() {
    this.clearResults()
  }

  disconnect() {
    if (this.searchTimer) clearTimeout(this.searchTimer)
  }

  queueSearch() {
    if (this.searchTimer) clearTimeout(this.searchTimer)
    this.searchTimer = setTimeout(() => this.search(), 150)
  }

  async search() {
    const q = this.queryTarget.value.trim()
    if (!q) {
      this.clearResults()
      return
    }

    try {
      const resp = await fetch(`/people/search?q=${encodeURIComponent(q)}`, {
        headers: { Accept: "application/json" }
      })

      if (!resp.ok) {
        this.resultsTarget.innerHTML = `<div class="text-danger small">Search failed</div>`
        return
      }

      const people = await resp.json()
      this.renderResults(people)
    } catch (e) {
      this.resultsTarget.innerHTML = `<div class="text-danger small">Search error</div>`
    }
  }

  renderResults(people) {
    if (!people.length) {
      this.resultsTarget.innerHTML = `<div class="text-muted small">No matches</div>`
      return
    }

    this.resultsTarget.innerHTML = people.map((p) => {
      const years = [p.birth, p.death].filter(Boolean).join("–")
      const meta = years ? ` <span class="text-muted small">(${years})</span>` : ""
      return `
        <button type="button"
                class="list-group-item list-group-item-action"
                data-action="click->person-picker#pick"
                data-person-id="${p.id}"
                data-person-label="${this.escapeHtml(p.label)}">
          ${this.escapeHtml(p.label)}${meta}
        </button>
      `
    }).join("")
  }

  pick(e) {
    const btn = e.currentTarget
    const id = btn.dataset.personId
    const label = btn.dataset.personLabel

    this.otherPersonIdTarget.value = id
    this.selectedLabelTarget.textContent = `${label} (#${id})`

    // Optional: collapse results after pick
    this.clearResults()
  }

  clearResults() {
    if (this.hasResultsTarget) this.resultsTarget.innerHTML = ""
    if (this.hasSelectedLabelTarget) this.selectedLabelTarget.textContent = "None"
    // don't clear otherPersonId automatically; user might have selected already
  }

  escapeHtml(str) {
    return (str || "").replace(/[&<>"']/g, (m) => ({
      "&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;","'":"&#039;"
    }[m]))
  }
}